module.exports = __webpack_public_path__ + "static/media/logo-berkley.773fdb91.svg";